import ApiService from '@services/api.service';
import {Notify} from 'quasar';

export const antenneInscription = {
  state: {
    inscription: null,
    inscriptions: [],
  },
  mutations: {
    setInsctiption(state, inscription){
      return state.inscription = inscription;
    },
    setInscriptions(state, inscriptions){
      return state.insctiptions = inscriptions;
    }
  },
  actions: {
    async addAntenneInscription(context, formData){
      try{
        const response  = await ApiService.postRequest('antenne_inscriptions', formData);
        context.commit('setInsctiption', response);

        Notify.create({
          message: "Inscription enregistrée avec succès.",
          color: "green"
        });

      }catch (error){
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout",
          color: 'red'
        });
      }
    },
    async editAntenneInscription(context, data){
      try{
        const response = await ApiService.putRequest(data.url, data.formData);
        context.commit('setInsctiption', response);

        Notify.create({
          message: "Inscription modifiée avec succès.",
          color: "green"
        });
      }catch(error){
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout",
          color: 'red'
        });
      }
    }
  },
  getters: {
    getInscription(state){
      return state.inscription;
    },
    getInscriptions(state){
      return state.inscriptions;
    }
  }
}
